import { useState } from "react";
import { useDetectClickOutside } from 'react-detect-click-outside';

const DropDown = ({ selection,selectionLabel,  placeholder, id, values, setSelection }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeDropdown = () => setIsOpen(false)
  const ref = useDetectClickOutside({ onTriggered: closeDropdown });
  const handleSelection = (val) => {
    setSelection(val, id);
    setIsOpen(false);
  };
  return (
    <div className="relative w-full " ref={ref}>
      <div
        className="px-4 py-1 border-primary border-2 flex flex-row items-center justify-between transition-all duration-300 cursor-pointer hover:text-primary hover:font-bold"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="capitalize">{selection && selectionLabel ? selectionLabel : placeholder}</span>
        <svg
          width="12"
          height="7"
          viewBox="0 0 12 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`transition-all duration-300 ease ${isOpen ? '' : 'rotate-180'}`}
        >
          <path
            d="M6.15967 0.982422L11.8165 6.63928H6.15967H0.502814L6.15967 0.982422Z"
            className="fill-primary"
          />
        </svg>
      </div>
      {isOpen && (
        <div className="absolute top-full mt-1 border-2 border-primary w-full cursor-pointer bg-white z-10">
          {values.map((v) => (
            <div
              className={`${v.type === selection ? "underline font-bold text-primary" : ""} border-b-[1px] border-primary last:border-b-0 capitalize hover:bg-primary hover:text-white`}
              key={v.type}
              onClick={() => handleSelection(v.type)}
            >
              {v.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default DropDown;
